/**
 * Priority and full country list for Adoption Form with Bosnian and English localization.
 */

export const COMMON_COUNTRIES = [
  {
    code: 'AT',
    nameEn: 'Austria',
    nameBs: 'Austrija',
    keywords: ['Österreich', 'Oesterreich'],
  },
  {
    code: 'DE',
    nameEn: 'Germany',
    nameBs: 'Njemačka',
    keywords: ['Deutschland', 'Njemacka'],
  },
  {
    code: 'CH',
    nameEn: 'Switzerland',
    nameBs: 'Švicarska',
    keywords: ['Schweiz', 'Suisse', 'Svizzera', 'Svicarska'],
  },
  {
    code: 'BA',
    nameEn: 'Bosnia and Herzegovina (BiH)',
    nameBs: 'Bosna i Hercegovina (BiH)',
    keywords: ['BiH', 'Bosna', 'Hercegovina', 'Bosnia'],
  },
  {
    code: 'GB',
    nameEn: 'United Kingdom (UK)',
    nameBs: 'Velika Britanija (UK)',
    keywords: [
      'UK',
      'Britain',
      'England',
      'Engleska',
      'Scotland',
      'Wales',
      'Ujedinjeno Kraljevstvo',
    ],
  },
  {
    code: 'DK',
    nameEn: 'Denmark',
    nameBs: 'Danska',
    keywords: ['Danmark'],
  },
  {
    code: 'CZ',
    nameEn: 'Czech Republic',
    nameBs: 'Češka',
    keywords: ['Czechia', 'Česká republika', 'Ceska'],
  },
];

export const PRIORITY_COUNTRIES = COMMON_COUNTRIES;

export const OTHER_COUNTRIES = [
  // Europe
  {
    code: 'AL',
    nameEn: 'Albania',
    nameBs: 'Albanija',
    keywords: ['Shqipëria'],
  },
  { code: 'AD', nameEn: 'Andorra', nameBs: 'Andora', keywords: [] },
  {
    code: 'BE',
    nameEn: 'Belgium',
    nameBs: 'Belgija',
    keywords: ['Belgique', 'België'],
  },
  {
    code: 'BG',
    nameEn: 'Bulgaria',
    nameBs: 'Bugarska',
    keywords: ['Bulgariya'],
  },
  { code: 'HR', nameEn: 'Croatia', nameBs: 'Hrvatska', keywords: ['Croatia'] },
  { code: 'CY', nameEn: 'Cyprus', nameBs: 'Kipar', keywords: ['Kypros'] },
  { code: 'EE', nameEn: 'Estonia', nameBs: 'Estonija', keywords: ['Eesti'] },
  { code: 'FI', nameEn: 'Finland', nameBs: 'Finska', keywords: ['Suomi'] },
  { code: 'FR', nameEn: 'France', nameBs: 'Francuska', keywords: ['France'] },
  {
    code: 'GR',
    nameEn: 'Greece',
    nameBs: 'Grčka',
    keywords: ['Hellas', 'Grcka'],
  },
  {
    code: 'HU',
    nameEn: 'Hungary',
    nameBs: 'Mađarska',
    keywords: ['Magyarország', 'Madjarska'],
  },
  { code: 'IS', nameEn: 'Iceland', nameBs: 'Island', keywords: ['Ísland'] },
  { code: 'IE', nameEn: 'Ireland', nameBs: 'Irska', keywords: ['Éire'] },
  { code: 'IT', nameEn: 'Italy', nameBs: 'Italija', keywords: ['Italia'] },
  { code: 'XK', nameEn: 'Kosovo', nameBs: 'Kosovo', keywords: ['Kosova'] },
  { code: 'LV', nameEn: 'Latvia', nameBs: 'Latvija', keywords: ['Latvija'] },
  {
    code: 'LI',
    nameEn: 'Liechtenstein',
    nameBs: 'Lihtenštajn',
    keywords: ['Lihtenstajn'],
  },
  {
    code: 'LT',
    nameEn: 'Lithuania',
    nameBs: 'Litvanija',
    keywords: ['Lietuva'],
  },
  {
    code: 'LU',
    nameEn: 'Luxembourg',
    nameBs: 'Luksemburg',
    keywords: ['Luxemburg'],
  },
  { code: 'MT', nameEn: 'Malta', nameBs: 'Malta', keywords: [] },
  { code: 'MD', nameEn: 'Moldova', nameBs: 'Moldavija', keywords: [] },
  { code: 'MC', nameEn: 'Monaco', nameBs: 'Monako', keywords: [] },
  {
    code: 'ME',
    nameEn: 'Montenegro',
    nameBs: 'Crna Gora',
    keywords: ['Montenegro'],
  },
  {
    code: 'NL',
    nameEn: 'Netherlands',
    nameBs: 'Holandija',
    keywords: ['Nizozemska', 'Nederland', 'Holland'],
  },
  {
    code: 'MK',
    nameEn: 'North Macedonia',
    nameBs: 'Sjeverna Makedonija',
    keywords: ['Makedonija'],
  },
  {
    code: 'NO',
    nameEn: 'Norway',
    nameBs: 'Norveška',
    keywords: ['Norge', 'Norveska'],
  },
  { code: 'PL', nameEn: 'Poland', nameBs: 'Poljska', keywords: ['Polska'] },
  {
    code: 'PT',
    nameEn: 'Portugal',
    nameBs: 'Portugal',
    keywords: ['Portugallia'],
  },
  { code: 'RO', nameEn: 'Romania', nameBs: 'Rumunija', keywords: ['România'] },
  { code: 'SM', nameEn: 'San Marino', nameBs: 'San Marino', keywords: [] },
  { code: 'RS', nameEn: 'Serbia', nameBs: 'Srbija', keywords: [] },
  {
    code: 'SK',
    nameEn: 'Slovakia',
    nameBs: 'Slovačka',
    keywords: ['Slovensko', 'Slovacka'],
  },
  { code: 'SI', nameEn: 'Slovenia', nameBs: 'Slovenija', keywords: [] },
  {
    code: 'ES',
    nameEn: 'Spain',
    nameBs: 'Španija',
    keywords: ['España', 'Spanija'],
  },
  {
    code: 'SE',
    nameEn: 'Sweden',
    nameBs: 'Švedska',
    keywords: ['Sverige', 'Svedska'],
  },
  { code: 'TR', nameEn: 'Turkey', nameBs: 'Turska', keywords: ['Türkiye'] },
  { code: 'UA', nameEn: 'Ukraine', nameBs: 'Ukrajina', keywords: [] },
  { code: 'VA', nameEn: 'Vatican City', nameBs: 'Vatikan', keywords: [] },

  // Americas
  {
    code: 'US',
    nameEn: 'United States',
    nameBs: 'Sjedinjene Američke Države (SAD)',
    keywords: ['USA', 'America', 'SAD', 'Amerika'],
  },
  { code: 'CA', nameEn: 'Canada', nameBs: 'Kanada', keywords: [] },
  { code: 'MX', nameEn: 'Mexico', nameBs: 'Meksiko', keywords: ['México'] },
  { code: 'AR', nameEn: 'Argentina', nameBs: 'Argentina', keywords: [] },
  { code: 'BR', nameEn: 'Brazil', nameBs: 'Brazil', keywords: ['Brasil'] },
  { code: 'CL', nameEn: 'Chile', nameBs: 'Čile', keywords: ['Cile'] },
  { code: 'CO', nameEn: 'Colombia', nameBs: 'Kolumbija', keywords: [] },
  { code: 'CR', nameEn: 'Costa Rica', nameBs: 'Kostarika', keywords: [] },
  { code: 'CU', nameEn: 'Cuba', nameBs: 'Kuba', keywords: [] },
  { code: 'EC', nameEn: 'Ecuador', nameBs: 'Ekvador', keywords: [] },
  { code: 'PA', nameEn: 'Panama', nameBs: 'Panama', keywords: [] },
  { code: 'PE', nameEn: 'Peru', nameBs: 'Peru', keywords: [] },
  { code: 'UY', nameEn: 'Uruguay', nameBs: 'Urugvaj', keywords: [] },

  // Oceania
  { code: 'AU', nameEn: 'Australia', nameBs: 'Australija', keywords: [] },
  { code: 'NZ', nameEn: 'New Zealand', nameBs: 'Novi Zeland', keywords: [] },

  // Asia & Middle East
  {
    code: 'AE',
    nameEn: 'United Arab Emirates',
    nameBs: 'Ujedinjeni Arapski Emirati (UAE)',
    keywords: ['UAE', 'Dubai', 'Emirati'],
  },
  { code: 'AM', nameEn: 'Armenia', nameBs: 'Armenija', keywords: [] },
  {
    code: 'AZ',
    nameEn: 'Azerbaijan',
    nameBs: 'Azerbejdžan',
    keywords: ['Azerbejdzan'],
  },
  { code: 'CN', nameEn: 'China', nameBs: 'Kina', keywords: [] },
  { code: 'GE', nameEn: 'Georgia', nameBs: 'Gruzija', keywords: [] },
  { code: 'IN', nameEn: 'India', nameBs: 'Indija', keywords: [] },
  { code: 'ID', nameEn: 'Indonesia', nameBs: 'Indonezija', keywords: [] },
  { code: 'IL', nameEn: 'Israel', nameBs: 'Izrael', keywords: [] },
  { code: 'JP', nameEn: 'Japan', nameBs: 'Japan', keywords: [] },
  { code: 'JO', nameEn: 'Jordan', nameBs: 'Jordan', keywords: [] },
  { code: 'KZ', nameEn: 'Kazakhstan', nameBs: 'Kazahstan', keywords: [] },
  { code: 'KW', nameEn: 'Kuwait', nameBs: 'Kuvajt', keywords: [] },
  { code: 'LB', nameEn: 'Lebanon', nameBs: 'Liban', keywords: [] },
  { code: 'MY', nameEn: 'Malaysia', nameBs: 'Malezija', keywords: [] },
  { code: 'PH', nameEn: 'Philippines', nameBs: 'Filipini', keywords: [] },
  { code: 'QA', nameEn: 'Qatar', nameBs: 'Katar', keywords: [] },
  {
    code: 'SA',
    nameEn: 'Saudi Arabia',
    nameBs: 'Saudijska Arabija',
    keywords: [],
  },
  { code: 'SG', nameEn: 'Singapore', nameBs: 'Singapur', keywords: [] },
  {
    code: 'KR',
    nameEn: 'South Korea',
    nameBs: 'Južna Koreja',
    keywords: ['Juzna Koreja', 'Korea'],
  },
  { code: 'TH', nameEn: 'Thailand', nameBs: 'Tajland', keywords: [] },
  { code: 'VN', nameEn: 'Vietnam', nameBs: 'Vijetnam', keywords: [] },

  // Africa
  { code: 'DZ', nameEn: 'Algeria', nameBs: 'Alžir', keywords: ['Alzir'] },
  { code: 'EG', nameEn: 'Egypt', nameBs: 'Egipat', keywords: [] },
  { code: 'MA', nameEn: 'Morocco', nameBs: 'Maroko', keywords: [] },
  {
    code: 'ZA',
    nameEn: 'South Africa',
    nameBs: 'Južnoafrička Republika',
    keywords: ['Juznoafricka Republika'],
  },
  { code: 'TN', nameEn: 'Tunisia', nameBs: 'Tunis', keywords: [] },
];

/**
 * Returns grouped react-select options formatted for the given language ('bs' or 'en').
 */
export const getCountryOptions = (lang = 'bs', labels = {}) => {
  const isBs = !lang || lang.toLowerCase().startsWith('bs');

  const priorityOptions = PRIORITY_COUNTRIES.map(country => ({
    value: country.code,
    label: isBs ? country.nameBs : country.nameEn,
    nameBs: country.nameBs,
    nameEn: country.nameEn,
    keywords: country.keywords,
  })).sort((a, b) => a.label.localeCompare(b.label, isBs ? 'bs' : 'en'));

  const otherOptions = OTHER_COUNTRIES.map(country => ({
    value: country.code,
    label: isBs ? country.nameBs : country.nameEn,
    nameBs: country.nameBs,
    nameEn: country.nameEn,
    keywords: country.keywords,
  })).sort((a, b) => a.label.localeCompare(b.label, isBs ? 'bs' : 'en'));

  const commonGroupLabel =
    labels.common_countries ||
    labels.priority_countries ||
    (isBs ? 'Najčešće' : 'The Most Common');
  const otherGroupLabel =
    labels.other_countries || (isBs ? 'Ostale države' : 'Other Countries');

  return [
    {
      label: commonGroupLabel,
      options: priorityOptions,
    },
    {
      label: otherGroupLabel,
      options: otherOptions,
    },
  ];
};

/**
 * Normalizes a string for forgiving search (ignores case, accents, and Bosnian special chars).
 */
export const normalizeSearchText = (str = '') =>
  str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'dj')
    .replace(/Đ/g, 'dj');

/**
 * Filter function for react-select allowing seamless search across native name, English name, Bosnian name, code and keywords.
 */
export const filterCountryOption = (candidate, input) => {
  if (!input) return true;
  const rawInput = input.trim();
  if (!rawInput) return true;

  const normalizedInput = normalizeSearchText(rawInput);
  const data = candidate.data;

  const corpus = normalizeSearchText(
    [
      candidate.label,
      data.nameBs,
      data.nameEn,
      data.value,
      ...(data.keywords || []),
    ].join(' ')
  );

  return corpus.includes(normalizedInput);
};
